var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Breadcrumb_out"},[_c('div',{staticClass:"Breadcrumb"},[_c('el-breadcrumb',{staticClass:"Breadcrumb_in",attrs:{"separator":"/"}},[_c('el-breadcrumb-item',[_vm._v(" "+_vm._s(_vm.Pagename)+" "),_c('i',{staticClass:"el-icon-refresh-left",on:{"click":_vm.relodePage}})])],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }